export default __webpack_public_path__ + "static/media/necromancer.7af8bcea.svg";